import { NgModule } from '@angular/core';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { SharedModule } from '../shared/shared.module';
import { MenuComponent } from './components/menu/menu.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { ProjectMenuComponent } from './components/project-menu/project-menu.component';


@NgModule({
  declarations: [NavBarComponent, MenuComponent, UserMenuComponent, FooterComponent, ProjectMenuComponent],
  imports: [
    SharedModule
  ],
  exports: [
    NavBarComponent
  ],
  entryComponents: [
    NavBarComponent,
    FooterComponent
  ]
})
export class LayoutModule { }
